import Curd from "./Curd";

export default class Manager extends Curd {
    BASE_PATH = "/user"

    sendMsg(id, msg) {
        return this.runPost(`/${id}`, {
            msg: msg
        })
    }
}